import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import EmailShareForm from './Form.js';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import { XIcon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

const initialState = {
    fetching: false,
};

class ShareEmailModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
    }
    closeModal = () => {
        this.setState( { ...initialState } );
        this.props.closeModal();
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        return this.props.submitHandler( values )
        .then( () => {
            this.setState( { fetching: false } );
        } )
        .catch( () => {
            this.setState( { fetching: false } );
        } );
    }
    render() {
        const { modalName, modalProps } = this.props;
        const isOpen = ( modalProps.modalIsOpen && modalName === 'shareEmailModal' );

        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Share via email"
            onRequestClose={ this.closeModal }
            className={ `modal-popup ${ style.shareEmailModal }` }
            overlayClassName='modal-overlay' >
                <div className='modal-title'>
                    <h2>Share via email</h2>
                </div>
                <div className='close-button' onClick={ this.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <EmailShareForm submitHandler={ this.submitHandler } closeModal={ this.props.closeModal }/>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};

export default connect( mapStateToProps )( ShareEmailModal );
